import React, { useState, useEffect } from 'react';
import { especialidadService } from '../services/api';
import '../styles/Especialidades.css';

const Especialidades = () => {
  const [especialidades, setEspecialidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [especialidadEditando, setEspecialidadEditando] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    activo: true
  });

  useEffect(() => {
    cargarEspecialidades();
  }, []);

  const cargarEspecialidades = async () => {
    try {
      const response = await especialidadService.getAll();
      setEspecialidades(response.data);
    } catch (error) {
      console.error('Error al cargar especialidades:', error);
    } finally {
      setLoading(false);
    }
  };

  const abrirModal = () => {
    setModoEdicion(false);
    setEspecialidadEditando(null);
    setFormData({
      nombre: '',
      descripcion: '',
      activo: true
    });
    setModalAbierto(true);
  };

  const abrirModalEdicion = (especialidad) => {
    setModoEdicion(true);
    setEspecialidadEditando(especialidad);
    setFormData({
      nombre: especialidad.nombre,
      descripcion: especialidad.descripcion || '',
      activo: especialidad.activo
    });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setModoEdicion(false);
    setEspecialidadEditando(null);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (modoEdicion) {
        await especialidadService.update(especialidadEditando.id, formData);
        alert('Especialidad actualizada exitosamente');
      } else {
        await especialidadService.create(formData);
        alert('Especialidad creada exitosamente');
      }

      cargarEspecialidades();
      cerrarModal();
    } catch (error) {
      console.error(`Error al ${modoEdicion ? 'actualizar' : 'crear'} especialidad:`, error);
      alert(error.response?.data?.error || `Error al ${modoEdicion ? 'actualizar' : 'crear'} especialidad`);
    }
  };

  const eliminarEspecialidad = async (id, nombre) => {
    if (!window.confirm(`¿Estás seguro de eliminar la especialidad "${nombre}"?`)) return;

    try {
      await especialidadService.delete(id);
      alert('Especialidad eliminada exitosamente');
      cargarEspecialidades();
    } catch (error) {
      console.error('Error al eliminar especialidad:', error);
      alert(error.response?.data?.error || 'Error al eliminar especialidad');
    }
  };

  if (loading) {
    return <div className="loading">Cargando especialidades...</div>;
  }

  return (
    <div className="especialidades-container">
      <div className="page-header">
        <h1>Especialidades</h1>
        <button className="btn btn-primary" onClick={abrirModal}>
          + Nueva Especialidad
        </button>
      </div>

      {especialidades.length === 0 ? (
        <div className="empty-state">
          <p>No hay especialidades registradas</p>
          <button className="btn btn-primary" onClick={abrirModal}>
            Crear primera especialidad
          </button>
        </div>
      ) : (
        <div className="especialidades-grid">
          {especialidades.map(especialidad => (
            <div key={especialidad.id} className="especialidad-card">
              <div className="especialidad-header">
                <h3>{especialidad.nombre}</h3>
                <span className={`estado-badge ${especialidad.activo ? 'activo' : 'inactivo'}`}>
                  {especialidad.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>

              {especialidad.descripcion && (
                <p className="especialidad-descripcion">{especialidad.descripcion}</p>
              )}

              <div className="especialidad-actions">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => abrirModalEdicion(especialidad)}
                >
                  ✏️ Editar
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => eliminarEspecialidad(especialidad.id, especialidad.nombre)}
                >
                  🗑️ Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{modoEdicion ? 'Editar Especialidad' : 'Nueva Especialidad'}</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Ej: Albañil, Electricista, Plomero"
                />
              </div>

              <div className="form-group">
                <label>Descripción</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  rows="3"
                  placeholder="Descripción de la especialidad"
                />
              </div>

              {modoEdicion && (
                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="activo"
                      checked={formData.activo}
                      onChange={handleChange}
                    />
                    <span>Activo</span>
                  </label>
                </div>
              )}

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {modoEdicion ? 'Guardar Cambios' : 'Crear Especialidad'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Especialidades;
